import { motion } from "framer-motion";

export default function KineticTitle() {
  return (
    <div
      data-testid="kinetic-title"
      className="select-none text-center flex flex-col items-center"
    >
      <motion.div
        initial={{ opacity: 0, scale: 0.72, filter: "blur(20px)" }}
        animate={{ opacity: 1, scale: 1, filter: "blur(0px)" }}
        transition={{ delay: 0.25, duration: 1.35, ease: [0.16, 1, 0.3, 1] }}
      >
        <motion.img
          src="/logo-main.png"
          alt="Logo Napoli Lounge"
          data-testid="hero-logo"
          animate={{ y: [0, -10, 0] }}
          transition={{
            duration: 6,
            repeat: Infinity,
            ease: "easeInOut",
            delay: 1.6,
          }}
          className="h-[clamp(9rem,32vh,20rem)] w-auto drop-shadow-[0_12px_40px_rgba(2,132,199,0.25)]"
        />
      </motion.div>
      <motion.p
        initial={{ opacity: 0, y: 14 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 1.05, duration: 0.9, ease: "easeOut" }}
        className="mt-6 sm:mt-8 text-sm sm:text-base text-sky-900/70 font-light tracking-wide"
      >
        Suoni sofisticati dal cuore di Napoli
      </motion.p>
    </div>
  );
}
